var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5955 21.214C30.6499 27.089 35.7499 29.0443 35.8061 29.0693C35.763 29.2068 34.9915 31.8556 33.1196 34.5909C31.5015 36.9559 29.8218 39.3121 27.1764 39.3615C24.5771 39.409 23.7411 37.8196 20.769 37.8196C17.7977 37.8196 16.8693 39.3121 14.4083 39.409C11.8546 39.5059 9.90989 36.8512 8.27833 34.4953C4.94458 29.6753 2.39676 20.8749 5.8177 14.9346C7.51708 11.9846 10.5546 10.1168 13.8511 10.0687C16.3586 10.0209 18.7255 11.7556 20.2583 11.7556C21.7902 11.7556 24.6665 9.66932 27.6902 9.97557C28.9561 10.0284 32.5093 10.4868 34.7908 13.8268C34.6074 13.9409 30.5515 16.3021 30.5955 21.214ZM25.7102 6.78713C27.0658 5.14619 27.9783 2.86119 27.7296 0.588379C25.7752 0.666816 23.4121 1.89057 22.0105 3.53088C20.7543 4.98307 19.6543 7.30807 19.9508 9.53588C22.1293 9.70463 24.3543 8.429 25.7102 6.78713Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.fb3e19c0d0b68208c97a7d9cb1c8dc69.svg";
export { ForwardRef as ReactComponent };